"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RATES_OF_CONFIRMATION = void 0;
var RATES_OF_CONFIRMATION = exports.RATES_OF_CONFIRMATION = {
  LOW: 'low',
  HIGH: 'high'
};